import { Component, ElementRef, Input } from '@angular/core';
import lottie, { AnimationItem } from 'lottie-web';
import { AnimationsService } from '../../services/animations.service';

@Component({
  selector: 'app-lottie-animation',
  templateUrl: './lottie-animation.component.html',
  styleUrls: ['./lottie-animation.component.scss']
})
export class LottieAnimationComponent {

  @Input()
  set animationData(value: { [key: string]: any }) {
    if (this._animationData !== value) {
      this._animationData = value;
      this.updateAnimation();
    }
  }
  get animationData(): { [key: string]: any } {
    return this._animationData;
  }

  @Input() animationName: string = '';
  @Input() autoplay: boolean = false;
  @Input() loop: boolean = false;

  private _animationData: any;
  private animationItem: AnimationItem | null = null;
  private hasViewInitialized = false;

  containerId = `lottie-container-${Math.random().toString(36).slice(2, 9)}`;

  constructor(
    private el: ElementRef,
    private animationsService: AnimationsService
  ) { }

  ngAfterViewInit(): void {
    this.hasViewInitialized = true;
    this.updateAnimation();
  }

  updateAnimation(): void {
    // Only update if view is initialized and we have data
    if (!this.hasViewInitialized || !this.animationData) {
      return;
    }
    // Destroy the current animation
    if (this.animationItem) {
      this.animationItem.destroy();
      this.animationItem = null;
    }

    this.initializeAnimation();
  }

  private initializeAnimation(): void {
    const container = this.el.nativeElement.querySelector(`#${this.containerId}`);

    this.animationItem = lottie.loadAnimation({
      container: container,
      renderer: 'svg',
      loop: this.loop,
      autoplay: this.autoplay,
      animationData: this.animationData
    });

    if (this.animationName) {
      this.animationsService.registerAnimation(this.animationName, this.animationItem);
    }
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    if (this.animationItem) {
      this.animationItem.destroy();
    }
  }

}
